
//性别
const ageList = [
    {
      name:'男',
      id:1
    },
    {
      name:'女',
      id:2
    }
  ]

//是否
const whether = [
    {
        name: "是",
        id: 1
      },
      {
        name: "否",
        id: 2
      }
]
//您所在的医院溶栓常规用药
const routine = [
    {
        name: "尿激酶原",
        id: 1
      },
      {
        name: "阿替普酶",
        id: 2
      },
      {
        name: "瑞替普酶",
        id: 3
      },
      {
        name: "替奈普酶",
        id: 4
      },
      {
        name: "其他",
        id: 5
      }
]
const section = [
  {
    name: "120",
    id: 1
  },
  {
    name: "急诊科",
    id: 2
  },
  {
    name: "心内科",
    id: 3
  },
  {
    name: "神经内科",
    id: 4
  },
  {
    name: "药剂科",
    id: 5
  },
  {
    name: "CCU",
    id: 6
  },
  {
    name: "ICU",
    id: 7
  },
  {
    name: "其它科室",
    id: 8
  }
]
const Rank = [
  {
    name: "护师",
    id: 0
  },
  {
    name: "医士",
    id: 1
  },
  {
    name: "医师",
    id: 2
  },
  {
    name: "住院医师",
    id: 3
  },
  {
    name: "主治医师",
    id: 4
  },
  {
    name: "副主任医师",
    id: 5
  },
  {
    name: "主任医师",
    id: 6
  }
]

const dutyList = [
  {
    name: "规培生",
    id: 1
  },
  {
    name: "护士",
    id: 2
  },
  {
    name: "医生",
    id: 3
  },
  {
    name: "科长",
    id: 4
  },
  {
    name: "主任",
    id: 5
  },
  {
    name: "副主任",
    id: 6
  },
  {
    name: "院长",
    id: 7
  },
  {
    name: "副院长",
    id: 8
  },
  {
    name: "其它",
    id: 9
  }
]
export {
    ageList,
    whether,
    routine,
    section,
    Rank,
    dutyList
}